export const browserTokenKey = "brwsrtkn";
export const browserPlatformLangKey = "browserPlatformLang";
